/**
 * Created by SMG on 2016/3/18.
 * Edit by ma.rongqin on 2016/3/20.
 */
'use strict';
angular.module('printModalModule', ['trsPrintModule']).controller('printModalCtrl', [
    '$http',
    '$q',
    '$scope',
    '$modalInstance',
    '$filter',
    'trsPrintService',
    'params',
    'trsHttpService',
    'trsspliceString',
    'modalDialog',
    'globleParamsSet',
    function($http, $q, $scope, $modalInstance, $filter, trsPrintService, params, trsHttpService, trsspliceString, modalDialog, globleParamsSet) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                params: params,
                currUserInfo: '',
            };
            $scope.status = {
                date: '',
                today: '',
            };
        }
        
        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            getSystemTime();
        }
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        $scope.printConfirm = function() {
            requestBasicInfo()
                .then(function(data) {
                    return requestTakeDraftInfo(data.content);
                })
                .then(function(data) {
                    var params = {
                        date: $filter('date')($scope.status.date).toString(),
                        sourceName: $scope.data.params.sourceName,
                        draftList: data,
                    };
                    trsPrintService.trsPrintDateList(params);
                    $modalInstance.dismiss();
                });
        };

        /**
         * [requestBasicInfo 请求列表基本信息]
         *
         * @return  {[type]}  [return description]
         */
        function requestBasicInfo() {
            var defer = $q.defer();
            var params = {
                typeId: 'zyzx',
                serviceId: $scope.data.params.channelName,
                modelid: 'print',
                typeName: $scope.data.params.typeName,
                keyword: {
                    time:
                        $filter('date')($scope.status.date, 'yyyy-MM-dd').toString() +
                        ',' +
                        $filter('date')($scope.status.date, 'yyyy-MM-dd').toString(),
                },
            };
            params.keyword = JSON.stringify(params.keyword);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (data.content.length == 0) {
                    modalDialog.alertType('', '列表信息为空', 'warning', 'confirm');
                    defer.reject(data);
                } else {
                    defer.resolve(data);
                }
            });
            return defer.promise;
        }

        /**
         * [requestTakeDraftInfo 请求取稿信息]
         *
         * @param   {[type]}  basicInfo  [basicInfo description]
         *
         * @return  {[type]}             [return description]
         */
        function requestTakeDraftInfo(basicInfo) {
            var defer = $q.defer();
            var draftList = angular.copy(basicInfo);
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'queryQUGroupList',
                guids: trsspliceString.spliceString(draftList, 'ZB_GUID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (angular.isDefined(data)) {
                    var content = data.DATA;
                    for (var i = 0; i < content.length; i++) {
                        for (var j = 0; j < draftList.length; j++) {
                            if (content[i].GUID == draftList[j].ZB_GUID) {
                                draftList[j].QULIST = angular.copy(content[i].QULIST);
                                break;
                            }
                        }
                    }
                }
                defer.resolve(draftList);
            });
            return defer.promise;
        }

        /**
         * [getSystemTime 获取服务器时间]
         *
         * @return  {[type]}  [return description]
         */
        function getSystemTime() {
            globleParamsSet.getServerTime().then((data) =>{
                $scope.status.today = $scope.status.date = new Date(data.LASTOPERTIME);
            });
        }
    },
]);
